import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9c6327c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-p-2 p-ml-2 p-component" }
const _hoisted_2 = { class: "header p-component" }
const _hoisted_3 = { class: "p-fluid p-formgrid p-grid p-p-0" }
const _hoisted_4 = { class: "p-field p-col-12 p-pl-0" }
const _hoisted_5 = { class: "p-col-3" }
const _hoisted_6 = { class: "p-col-3" }
const _hoisted_7 = { class: "p-field p-col-12 p-pl-0" }
const _hoisted_8 = { class: "p-col-3" }
const _hoisted_9 = { class: "p-col-3" }
const _hoisted_10 = { class: "p-field p-col-12 p-pl-0 p-mb-0" }
const _hoisted_11 = { class: "p-col-3" }
const _hoisted_12 = { class: "p-col-3" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-information-variant" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-file-clock-outline" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-image-outline" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-format-color-fill" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-file-replace-outline" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Divider = _resolveComponent("Divider")!
  const _component_SystemInformation = _resolveComponent("SystemInformation")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_SystemCleanUpConfig = _resolveComponent("SystemCleanUpConfig")!
  const _component_SystemThemeUploadView = _resolveComponent("SystemThemeUploadView")!
  const _component_SystemColorPickerView = _resolveComponent("SystemColorPickerView")!
  const _component_SystemCsvTranslationView = _resolveComponent("SystemCsvTranslationView")!
  const _component_Accordion = _resolveComponent("Accordion")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('Squeeze.System.System')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('Squeeze.System.Version')) + ": ", 1),
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.systemVersion), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('Squeeze.General.Tenant')) + ": ", 1),
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.store.state.systemInformation.tenant), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('Squeeze.General.TenantName')) + ": ", 1),
        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.store.state.systemInformation.tenantName), 1)
      ])
    ]),
    _createVNode(_component_Divider),
    _createVNode(_component_Accordion, {
      multiple: true,
      activeIndex: [],
      lazy: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AccordionTab, null, {
          header: _withCtx(() => [
            _hoisted_13,
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('Squeeze.System.System')) + " " + _toDisplayString(_ctx.$t('Squeeze.System.Info')), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_SystemInformation, {
              systemInformation: _ctx.store.state.systemInformation.labels
            }, null, 8, ["systemInformation"])
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, null, {
          header: _withCtx(() => [
            _hoisted_14,
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('Squeeze.System.SystemCleanUp')), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_SystemCleanUpConfig, {
              systemCleanUpConfig: _ctx.systemCleanUpConfig,
              loading: _ctx.loading
            }, null, 8, ["systemCleanUpConfig", "loading"])
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, null, {
          header: _withCtx(() => [
            _hoisted_15,
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('Squeeze.System.ImageUpload')), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_SystemThemeUploadView)
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, null, {
          header: _withCtx(() => [
            _hoisted_16,
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('Squeeze.System.ColorPicker')), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_SystemColorPickerView)
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, null, {
          header: _withCtx(() => [
            _hoisted_17,
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('Squeeze.System.CSVTranslations')), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_SystemCsvTranslationView)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}